<template>
  <section class="wrapper"
    element-loading-text="地图加载中..."
    v-loading="!maploaded">
    <div id="v1-map-container" style="height: 100%; z-index: 0;"></div>
    <div class="slide-panel-container">
      <div class="slide-panel" :class="{ hide: !showSlidePanel }">
        <el-row style="display: flex;">
          <el-select
            style="flex: 1"
            size="small"
            v-model="viewProjectId"
            placeholder="请选择项目"
            @change="changeProject">
            <el-option
              v-for="item in projects"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <table v-if="viewProject" class="project-info-table">
            <tr>
              <td><i class="el-icon-s-home"></i> {{ viewProject.name }}</td>
            </tr>
            <tr>
              <td>
                <i class="el-icon-office-building"></i>
                项目地址：{{ viewProject.address }}
              </td>
            </tr>
            <tr>
              <td>
                <i class="el-icon-map-location"></i>
                经纬坐标：{{ [viewProject.longitude, viewProject.latitude].join(' , ') }}
                <el-link
                  :underline="false"
                  class="background-link"
                  style="color: white"
                  icon="el-icon-zoom-in"
                  @click="locateProject">
                  定位
                </el-link>
                <el-link
                  :underline="false"
                  class="background-link"
                  style="color: white"
                  icon="el-icon-zoom-out"
                  @click="zoomOut">
                  返回
                </el-link>
              </td>
            </tr>
          </table>

          <el-input
            size="small"
            prefix-icon="el-icon-search"
            placeholder="过滤孔号"
            v-model="filterText">
          </el-input>

          <template v-if="filterAdmDevices.length > 0">
            <ADMStatesTable :deviceStates="filterAdmDevices"></ADMStatesTable>
          </template>
          <template v-if="filterDevices.length > 0">
            <DeviceStatesTable :deviceStates="filterDevices"></DeviceStatesTable>
          </template>
        </el-row>
      </div>

      <div>
        <el-link
          class="background-link"
          style="font-size: 14px; color: white"
          icon="el-icon-open"
          :underline="false"
          @click="toggleSlidePanel">
          {{toggleSlidePanelContent}}
        </el-link>
      </div>

    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DeviceStatesTable from '@/components/v1/DeviceStatesTable';
import ADMStatesTable from '@/components/v1/ADMStatesTable';
import { getDeviceStates } from '@/api';
import { ADM } from '@/utils/constants';
import { appName } from '@/utils/helpers';
import MapService from '@/services/map';

export default {
  components: {
    DeviceStatesTable,
    ADMStatesTable,
  },
  data() {
    return {
      maploaded: false,
      mapService: new MapService('v1-map-container'),
      startZoom: 5,
      startCenter: { lat: 32, lng: 110 },
      infoWindow: null,
      viewProjectId: null,
      filterText: '',
      devices: [],
      showSlidePanel: true,
    };
  },
  beforeCreate() {
    MapService.loadScript();
  },
  computed: {
    ...mapState('project', ['projects']),
    ...mapGetters('admin', ['fakeState']),
    viewProject() {
      return this.projects.find(p => p.id === this.viewProjectId);
    },
    toggleSlidePanelContent() {
      return this.showSlidePanel ? '收起面板' : '展开面板';
    },
    filterDevices() {
      const list = this.devices.filter((item) => {
        const isNoAdm = item.type !== ADM;
        const hitName = ~item.deviceName.indexOf(this.filterText);
        const hitBranchName = item.Branch && item.Branch.name
          && (~item.Branch.name.indexOf(this.filterText));
        return isNoAdm && (hitName || hitBranchName);
      });
      return list;
    },
    filterAdmDevices() {
      const list = this.devices.filter((item) => {
        const isAdm = item.type === ADM;
        const hitName = ~item.deviceName.indexOf(this.filterText);
        const hitBranchName = item.Branch && item.Branch.name
          && (~item.Branch.name.indexOf(this.filterText));
        return isAdm && (hitName || hitBranchName);
      });
      return list;
    },
  },
  watch: {
    viewProjectId() {
      this.getDeviceStates();
    },
  },
  mounted() {
    this.mapService.initMap(() => {
      this.updateViewProjectId();
      this.renderMarkers();
      this.maploaded = true;
    });
  },
  methods: {
    updateViewProjectId() {
      if (this.projects.length) {
        const topProject = this.projects[0];
        this.viewProjectId = topProject.id;
      }
    },

    // 渲染项目标记点
    renderMarkers() {
      this.projects
        .filter(item => item.longitude && item.latitude)
        .forEach((item) => {
          const {
            id, name, longitude, latitude,
            onlineErrorCount, collectErrorCount, exceedErrorCount,
          } = item;
          const lng = +longitude;
          const lat = +latitude;

          let color = 'green';
          if (!this.fakeState) {
            if (exceedErrorCount > 0) {
              color = 'red';
            } else if (onlineErrorCount > 0 || collectErrorCount > 0) {
              color = 'yellow';
            }
          }
          const label = name;

          this.mapService.addMarker({
            lat, lng, id, color, label,
          });
          this.mapService.addListenerToMarker(id, 'click', () => {
            const project = this.projects.find(p => p.id === id);
            this.enterProject(project);
          });
          this.mapService.addListenerToMarker(id, 'mouseover', () => {
            const project = this.projects.find(p => p.id === id);
            const abnormalIntel = appName === 'nssy' ? project.collectErrorCount : project.onlineErrorCount;
            const content = this.setInfoWindowContent({
              名称: project.name,
              经纬坐标: [project.longitude, project.latitude].join(', '),
              网络异常数: this.fakeState ? 0 : abnormalIntel,
              采集异常数: this.fakeState ? 0 : project.collectErrorCount,
              告警异常数: this.fakeState ? 0 : project.exceedErrorCount,
              设备总数: project.totalDevicesCount,
            });
            this.mapService.setInfoWindowContent(content);
            this.mapService.openMarkerInfoWindow(id);
          });
          this.mapService.addListenerToMarker(id, 'mouseout', () => {
            this.mapService.closeInfoWindow();
          });
        });
      this.mapService.renderCluster();
    },

    setInfoWindowContent(contentObj) {
      const labels = Object.keys(contentObj);
      const trs = labels.map((label) => {
        const content = contentObj[label];
        return `<tr><td class="label">${label}</td><td class="content">${content}</td></tr> `;
      });

      return `<div class="map-info-window"><table>${trs.join('')}</table></div> `;
    },

    // 定位项目，地图放大
    locateProject() {
      const project = this.viewProject;
      if (project) {
        const { longitude, latitude } = project;
        this.zoomIn(longitude, latitude);
        this.toggleSlidePanel();
      }
    },

    zoomIn(lng, lat, zoom = 18) {
      this.mapService.setCenter({ lat: +lat, lng: +lng });
      this.mapService.setZoom(zoom);
    },

    // 地图恢复到初始状态
    zoomOut() {
      this.mapService.setCenter(this.startCenter);
      this.mapService.setZoom(this.startZoom);
    },

    // 切换项目，跳转到项目首页
    enterProject(project) {
      this.$store.dispatch('project/changeProject', { project }).then(() => {
        this.$router.push({ name: 'home' });
      });
    },

    // 下拉选中项目，切换设备列表
    changeProject() {
      const { longitude, latitude } = this.viewProject;
      this.zoomIn(longitude, latitude, 8);
    },

    getDeviceStates() {
      // 获取选中项目的设备
      getDeviceStates({ projectId: this.viewProjectId }).then((res) => {
        this.devices = res.data.deviceStates;
      });
    },

    toggleSlidePanel() {
      this.showSlidePanel = !this.showSlidePanel;
    },
  },
};
</script>

<style lang="scss">
@import '~styles/variables';

.wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  .slide-panel-container {
    position: absolute;
    top: 2px;
    left: 2px;
    padding: 10px;
    max-height: 80vh;
    max-width: 99%;
    box-sizing: border-box;
    overflow: auto;
    background-color: rgba(255,255,255,.5);
    .slide-panel {
      margin-bottom: 10px;
      &.hide {
        display: none;
      }
    }
  }
  .top-right-controls {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}

.project-info-table {
  width: 100%;
  color: #333;
}

.amap-marker-label {
  border: 0;
  background-color: transparent;
}
.project-marker {
  display: flex;
  align-items: center;
  img {
    width: 30px;
    height: 30px;
  }
  .marker-content {
    padding: 2px 5px;
    background-color: $border-color;
    border-radius: 1px;
    word-break: keep-all;
    white-space: nowrap;
    font-size: 12px;
    color: #222;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      color: $blue;
    }
  }
}
.background-link {
  padding: 0 5px;
  background-color: rgba(0,0,0,.5);
  color: white;
}
</style>

